import React from 'react';
import Skeleton from '@mui/material/Skeleton';

const RectSkeleton = ({ width = 210, height = 60, style }) => {
  return <Skeleton variant="rectangular" width={width} height={height} sx={style} />;
};

export default RectSkeleton;
